<template>
  <div class="home">
    <TextToSpeech />
    <InfoSection />
  </div>
</template>

<script>
import TextToSpeech from '@/components/TextToSpeech.vue'
import InfoSection from '@/components/InfoSection.vue'

export default {
  name: 'HomePage',
  components: {
    TextToSpeech,
    InfoSection
  },
}
</script>